/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Platform_Team_No_DoubleInputs */

const en_platform_team_no_double = /** @type {(inputs: Platform_Team_No_DoubleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`no double bookings`)
};

const pl_platform_team_no_double = /** @type {(inputs: Platform_Team_No_DoubleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`bez podwójnych rezerwacji`)
};

/**
* | output |
* | --- |
* | "no double bookings" |
*
* @param {Platform_Team_No_DoubleInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const platform_team_no_double = /** @type {((inputs?: Platform_Team_No_DoubleInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Platform_Team_No_DoubleInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_platform_team_no_double(inputs)
	return en_platform_team_no_double(inputs)
});